import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { OriginalRow, TableProps } from 'components/Table';
import { AppliedFilters, ConfiguratorState, UpdateTableRowsVendor } from 'models/configurator';
import { SearchSubject } from 'models/response';

const setSelectedCompanyVendorConfig: CaseReducer<
  ConfiguratorState,
  PayloadAction<{ value: number; label: string } | null>
> = (state, { payload }) => {
  state.vendor.selectedCompanyVendorConfig = payload;
};

const setAppliedFilters: CaseReducer<ConfiguratorState, PayloadAction<AppliedFilters>> = (state, { payload }) => {
  state.vendor.appliedFilters = payload;
};

const setSubjectList: CaseReducer<ConfiguratorState, PayloadAction<SearchSubject[]>> = (state, { payload }) => {
  state.vendor.subjectList = payload;
};

const setSelectedVendorIdFromList: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.vendor.selectedVendorIdFromList = payload;
};

const setIdEditedVendorFromList: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.vendor.idEditedVendorFromList = payload;
};

const setIsEditedVendorDetail: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.vendor.isEditedVendorDetail = payload;
};

const setSubjectTableColumns: CaseReducer<ConfiguratorState, PayloadAction<TableProps['columns']>> = (
  state,
  { payload },
) => {
  state.vendor.subjectTableColumns = payload;
};

const setEditedRowIdSubjectDetails: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.vendor.subjectDetails.editedRowId = payload;
};

const setSelectedRowIdSubjectDetails: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.vendor.subjectDetails.selectedRowId = payload;
};

const setSubjectDetailsTableRows: CaseReducer<ConfiguratorState, PayloadAction<OriginalRow[]>> = (
  state,
  { payload }
) => {
  state.vendor.subjectDetails.tableRows = payload
};

const updateVendorTableRow: CaseReducer<ConfiguratorState, PayloadAction<UpdateTableRowsVendor>> = (
  state, { payload: { idWSubject, newRow } }
) => {  
  state.vendor.subjectList = state.vendor.subjectList.map((row) => {
    return row.idWSubject === idWSubject ? newRow : row
  });
};

export default {
  setSelectedCompanyVendorConfig,
  setAppliedFilters,
  setSubjectList,
  setSelectedVendorIdFromList,
  setIdEditedVendorFromList,
  setIsEditedVendorDetail,
  setSubjectTableColumns,
  setEditedRowIdSubjectDetails,
  setSelectedRowIdSubjectDetails,
  setSubjectDetailsTableRows,
  updateVendorTableRow
};
